export default __webpack_public_path__ + "static/media/content3_2.44a6e30e.png";